import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, resolveDirective as _resolveDirective, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  id: "app",
  class: "indexPage"
}
const _hoisted_2 = { class: "indexBanner background-white" }
const _hoisted_3 = { class: "indexBannerInner" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = {
  key: 0,
  class: "error"
}
const _hoisted_6 = {
  key: 1,
  class: "loading"
}
const _hoisted_7 = {
  class: "filterIndexHeaderArea",
  "data-aos": "fade-up",
  "data-aos-duration": "1200",
  "data-aos-delay": "0"
}
const _hoisted_8 = { class: "headerTitle" }
const _hoisted_9 = {
  "data-aos": "fade-up",
  "data-aos-duration": "1200",
  "data-aos-delay": "400"
}
const _hoisted_10 = {
  class: "largePreamble",
  "data-aos": "fade-up",
  "data-aos-duration": "1200",
  "data-aos-delay": "800"
}
const _hoisted_11 = { class: "indexFilters background-beige" }
const _hoisted_12 = { class: "container" }
const _hoisted_13 = {
  key: 0,
  class: "indexFiltersWrapper"
}
const _hoisted_14 = ["aria-label"]
const _hoisted_15 = {
  key: 0,
  class: "searchButton"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("svg", {
  role: "img",
  "aria-hidden": "true",
  viewBox: "0 0 17 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M2 6.26829C2 3.91098 3.91098 2 6.26829 2C8.62561 2 10.5366 3.91098 10.5366 6.26829C10.5366 8.62561 8.62561 10.5366 6.26829 10.5366C3.91098 10.5366 2 8.62561 2 6.26829ZM6.26829 0C2.80641 0 0 2.80641 0 6.26829C0 9.73018 2.80641 12.5366 6.26829 12.5366C7.63832 12.5366 8.9057 12.0971 9.9371 11.3513L15.1869 16.6011L16.6011 15.1869L11.3513 9.9371C12.0971 8.9057 12.5366 7.63832 12.5366 6.26829C12.5366 2.80641 9.73018 0 6.26829 0Z"
  })
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("svg", {
  role: "img",
  "aria-hidden": "true",
  viewBox: "0 0 17 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M0 0H17V2H0V0ZM2 6H15V8H2V6ZM12 12H5V14H12V12Z"
  })
], -1)
const _hoisted_18 = { class: "filterTitle" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("svg", {
  role: "img",
  "aria-hidden": "true",
  viewBox: "0 0 17 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M0 0H17V2H0V0ZM2 6H15V8H2V6ZM12 12H5V14H12V12Z"
  })
], -1)
const _hoisted_20 = ["aria-label"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("svg", {
  "aria-hidden": "true",
  role: "img",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("line", {
    x1: "7.37361",
    y1: "7.62615",
    x2: "22.3737",
    y2: "22.6263",
    "stroke-width": "2"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "7.62639",
    y1: "22.6263",
    x2: "22.6265",
    y2: "7.62616",
    "stroke-width": "2"
  })
], -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { for: "searchFilterInput" }
const _hoisted_24 = { class: "searchInputFilterWrapper" }
const _hoisted_25 = ["placeholder"]
const _hoisted_26 = ["aria-label"]
const _hoisted_27 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19",
  height: "18",
  viewBox: "0 0 19 18",
  preserveAspectRatio: "xMinYMid",
  "aria-hidden": "true",
  role: "img",
  fill: "#1A1347"
}, [
  /*#__PURE__*/_createElementVNode("g", null, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M315.25 20.25V31H326v1.5h-10.75v10.75h-1.5V32.5H303V31h10.75V20.25h1.5z",
      transform: "translate(-305 -79) translate(0 56) rotate(45 314.5 31.75)"
    })
  ])
], -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = {
  key: 1,
  class: "searchInputErrorMessage"
}
const _hoisted_30 = { class: "panelResults" }
const _hoisted_31 = {
  key: 0,
  class: "filterItemsResultsWrapper"
}
const _hoisted_32 = { class: "applyButton setting-closeButton" }
const _hoisted_33 = { class: "filterItemsWrapper" }
const _hoisted_34 = { class: "indexItemsWrapper background-beige" }
const _hoisted_35 = { class: "resultSort" }
const _hoisted_36 = { class: "container" }
const _hoisted_37 = { class: "totalResultsWrapper" }
const _hoisted_38 = {
  key: 1,
  class: "noResults"
}
const _hoisted_39 = { class: "container" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "noResultsIcon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    role: "img",
    "aria-hidden": "true",
    viewBox: "0 0 55 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M54.23 83V34.22C54.2004 31.3975 53.0869 28.6944 51.12 26.67C50.0867 25.5519 49.4872 24.1013 49.4299 22.58L48.26 0H36.97L35.7999 22.58C35.7507 24.1012 35.1542 25.5534 34.12 26.67C32.1446 28.6978 31.0272 31.4092 31 34.24V45.24H0V46.74C0 55.62 7.61 62.94 17.25 63.63V80H10.7V83H26.7V80H20.1899V63.63C24.0928 63.3755 27.83 61.9579 30.9199 59.56V83H54.23ZM33.97 80V75.87H51.23V80H33.97ZM33.97 34.26C33.999 32.2016 34.8106 30.2315 36.24 28.75C37.7811 27.1217 38.6799 24.9901 38.7699 22.75L39.7699 3.02002H45.36L46.36 22.75C46.4509 24.988 47.3456 27.1183 48.88 28.75C50.3109 30.2183 51.1234 32.1799 51.1499 34.23V72.86H33.8899V56.6C36.1475 53.8083 37.3857 50.3303 37.3999 46.74V45.24H33.8899L33.97 34.26ZM18.7 60.69C10.59 60.69 3.88992 55.23 3.03992 48.24H34.36C34.279 48.9177 34.1385 49.587 33.9399 50.24C33.355 52.1965 32.3286 53.9927 30.9399 55.49C29.3691 57.1546 27.4707 58.476 25.3641 59.371C23.2576 60.2659 20.9886 60.715 18.7 60.69V60.69Z",
      fill: "#00341C"
    })
  ])
], -1)
const _hoisted_41 = { class: "largePreamble" }
const _hoisted_42 = {
  key: 0,
  class: "error"
}
const _hoisted_43 = {
  key: 2,
  class: "loading"
}
const _hoisted_44 = { class: "container" }
const _hoisted_45 = { class: "showMoreButton" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PreSelectedFilters = _resolveComponent("PreSelectedFilters")!
  const _component_Filters = _resolveComponent("Filters")!
  const _component_ChosenTags = _resolveComponent("ChosenTags")!
  const _component_SortOrderDropDown = _resolveComponent("SortOrderDropDown")!
  const _component_ResultsReturned = _resolveComponent("ResultsReturned")!
  const _component_ResultItemsContainer = _resolveComponent("ResultItemsContainer")!
  const _component_ResultsIndicator = _resolveComponent("ResultsIndicator")!
  const _component_RenderResources = _resolveComponent("RenderResources")!
  const _component_RenderSettings = _resolveComponent("RenderSettings")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_RenderSettings, {
      parentid: _ctx.parentid,
      endPoint: _ctx.apiendpoint,
      culture: _ctx.language
    }, {
      settings: _withCtx(({ settings, settingsLoading, settingsError }) => [
        _createElementVNode("section", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              settingsError
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t("Web.Containers.LoadingError")), 1))
                : _createCommentVNode("", true),
              (settingsLoading && !settingsError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.$t("Web.Containers.LoadingFilters")), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("h1", _hoisted_9, _toDisplayString(settings.title), 1),
                  _createElementVNode("p", _hoisted_10, _toDisplayString(settings.description), 1)
                ]),
                _createVNode(_component_PreSelectedFilters, {
                  selectedFilter: _ctx.preselectedFilterItem,
                  selectedFilters: settings.selectedFilters,
                  onPreSelectedFilterClick: _ctx.clickFilters
                }, null, 8, ["selectedFilter", "selectedFilters", "onPreSelectedFilterClick"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              (
                  settings?.sortOrder?.length > 0 ||
                    settings.enableKeywordSearch ||
                    settings.taxonomy?.tagGroups.length > 0
                )
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createElementVNode("button", {
                      class: "modalButtons",
                      "aria-expanded": "false",
                      "aria-controls": "indexFilterPanelControl",
                      id: "indexFilterPanelID",
                      "aria-label": _ctx.$t('Web.Aria.OpenFilters'),
                      ref: "panelButton",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.filterSidebarClick && _ctx.filterSidebarClick(...args)))
                    }, [
                      (settings.enableKeywordSearch)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _hoisted_16,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t("Web.Containers.Search")), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (settings.taxonomy?.tagGroups.length > 0)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: _normalizeClass(["filterButton", 
                      !settings.enableKeywordSearch ? 'noKeywordSearch' : ''
                    ])
                          }, [
                            _hoisted_17,
                            _createTextVNode(" " + _toDisplayString(_ctx.$t("Web.Containers.Filter")), 1)
                          ], 2))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_14),
                    _withDirectives((_openBlock(), _createElementBlock("form", {
                      class: "indexFiltersModal",
                      id: "indexFilterPanelControl",
                      role: "region",
                      "aria-labelledby": "indexFilterPanelID",
                      "aria-hidden": "true",
                      onSubmit: _cache[11] || (_cache[11] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.trySearch && _ctx.trySearch(...args)), ["prevent"])),
                      ref: "panelContent",
                      onKeydown: _cache[12] || (_cache[12] = _withKeys(
//@ts-ignore
(...args) => (_ctx.panelEsc && _ctx.panelEsc(...args)), ["esc"]))
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["filterTitleWrapper", 
                      !settings.enableKeywordSearch ? 'noKeywordSearch' : ''
                    ])
                      }, [
                        _createElementVNode("div", _hoisted_18, [
                          _hoisted_19,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("Web.Containers.Filter")), 1)
                        ]),
                        _createElementVNode("button", {
                          class: "filterModalClose",
                          "aria-label": _ctx.$t('Web.Aria.CloseFilters'),
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.filterSidebarCloseClick && _ctx.filterSidebarCloseClick(...args)))
                        }, _hoisted_22, 8, _hoisted_20),
                        (settings.enableKeywordSearch)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: _normalizeClass(["searchInput", _ctx.keywordError && 'searchError'])
                            }, [
                              _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t("Web.Containers.SearchLabel")), 1),
                              _createElementVNode("div", _hoisted_24, [
                                _withDirectives(_createElementVNode("input", {
                                  id: "searchFilterInput",
                                  onKeydown: _cache[2] || (_cache[2] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.trySearch && _ctx.trySearch(...args)), ["prevent"]), ["enter"])),
                                  type: "search",
                                  placeholder: _ctx.$t('Web.Containers.SearchLabel'),
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.keyword) = $event)),
                                  autocomplete: "off"
                                }, null, 40, _hoisted_25), [
                                  [_vModelText, _ctx.keyword]
                                ]),
                                (_ctx.keyword.length > 0)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      class: "clearButton",
                                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clearKeyword && _ctx.clearKeyword(...args))),
                                      "aria-label": _ctx.$t('Web.Containers.ClearKeyword')
                                    }, _hoisted_28, 8, _hoisted_26))
                                  : _createCommentVNode("", true),
                                (_ctx.keywordError)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(_ctx.$t("Web.Containers.SearchErrorKeywordLength")), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ], 2))
                          : _createCommentVNode("", true)
                      ], 2),
                      _createElementVNode("div", {
                        class: _normalizeClass(["indexFiltersInner", 
                      !settings.enableKeywordSearch ? 'noKeywordSearch' : ''
                    ])
                      }, [
                        _createVNode(_component_Filters, {
                          tagGroups: settings.taxonomy?.tagGroups,
                          onSelectedTagsUpdated: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateCurrentSelectedTags($event))),
                          onTagUpdated: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateTags($event))),
                          selectedTags: _ctx.currentSelectedTags,
                          class: "selectWrapper"
                        }, null, 8, ["tagGroups", "selectedTags"]),
                        _createElementVNode("div", _hoisted_30, [
                          (_ctx.currentSelectedTags.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                _createVNode(_component_ChosenTags, {
                                  tags: _ctx.currentSelectedTags,
                                  onClearTag: _cache[7] || (_cache[7] = 
                            (tag) => {
                              _ctx.currentSelectedTags.splice(
                                _ctx.currentSelectedTags.indexOf(tag),
                                1
                              );
                            }
                          )
                                }, null, 8, ["tags"]),
                                (_ctx.tags.length > 0)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      class: "clearAll",
                                      onClick: _cache[8] || (_cache[8] = 
                            () => {
                              _ctx.currentSelectedTags = [];
                            }
                          )
                                    }, _toDisplayString(_ctx.$t("Web.Containers.ClearAll")), 1))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("button", {
                              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args))),
                              onKeydown: _cache[10] || (_cache[10] = _withKeys(
//@ts-ignore
(...args) => (_ctx.lastFocusTab && _ctx.lastFocusTab(...args)), ["tab"]))
                            }, _toDisplayString(_ctx.$t("Web.Containers.Apply")), 33)
                          ])
                        ])
                      ], 2)
                    ], 32)), [
                      [_directive_click_outside, _ctx.onClickOutsideFilterPanel]
                    ]),
                    (settings?.sortOrder.length > 1)
                      ? (_openBlock(), _createBlock(_component_SortOrderDropDown, {
                          key: 0,
                          dropdownId: 'indexSortBy',
                          options: settings?.sortOrder,
                          label: 'Sort by',
                          onSortOrderChange: _ctx.updateSortData
                        }, null, 8, ["options", "onSortOrderChange"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.tags.length > 0)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "appliedResults",
                    "on:clearTag": _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.clearTag && _ctx.clearTag(...args)))
                  }, [
                    (_ctx.tags.length > 0)
                      ? (_openBlock(), _createElementBlock("p", {
                          key: 0,
                          "on:clearTag": _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.clearTag && _ctx.clearTag(...args)))
                        }, _toDisplayString(_ctx.$t("Web.Containers.AppliedFilters")) + ": ", 33))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_33, [
                      _createVNode(_component_ChosenTags, {
                        tags: _ctx.tags,
                        onClearTag: _ctx.clearTag
                      }, null, 8, ["tags", "onClearTag"]),
                      (_ctx.tags.length > 0)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "clearAll",
                            onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.clearAllTags && _ctx.clearAllTags(...args)))
                          }, _toDisplayString(_ctx.$t("Web.Containers.ClearAll")), 1))
                        : _createCommentVNode("", true)
                    ])
                  ], 32))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createVNode(_component_RenderResources, {
            parentid: _ctx.parentid,
            endPoint: _ctx.apiendpoint,
            tags: _ctx.selectedTags,
            images: _ctx.images,
            additionalFields: _ctx.additionalFields,
            additionalFieldsMultiLingual: _ctx.additionalFieldsMultiLingual,
            page: _ctx.currentActivePage,
            keyword: _ctx.keywordInput,
            pagesize: _ctx.pagesize,
            sortOrder: _ctx.sortOrder,
            sortType: _ctx.sortType,
            sortIsDesc: _ctx.sortIsDesc,
            language: _ctx.language,
            personalisationGroupIds: _ctx.personalisationGroupIds,
            onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.resourcesChanged($event, _ctx.pagesize)))
          }, {
            search: _withCtx(({ result, loading, error }) => [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    (
                        !loading &&
                          !error &&
                          result.results !== undefined &&
                          result.results.length > 0
                      )
                      ? (_openBlock(), _createBlock(_component_ResultsReturned, {
                          key: 0,
                          totalResults: result.totalResults,
                          indexType: _ctx.title
                        }, null, 8, ["totalResults", "indexType"]))
                      : _createCommentVNode("", true),
                    (
                        !loading &&
                          !error &&
                          (result === undefined ||
                            result.results === undefined ||
                            result.results.length === 0)
                      )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                          _createElementVNode("div", _hoisted_39, [
                            _createVNode(_component_ResultsReturned, {
                              totalResults: result.totalResults,
                              indexType: _ctx.title
                            }, null, 8, ["totalResults", "indexType"]),
                            _hoisted_40,
                            _createElementVNode("p", _hoisted_41, _toDisplayString(_ctx.$t("Web.Containers.NoResults")), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  error
                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(_ctx.$t("Web.Containers.LoadingResourceError")), 1))
                    : _createCommentVNode("", true),
                  (
                      !error &&
                        result.results !== undefined &&
                        result.results.length > 0
                    )
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass(["indexItems", _ctx.resultType])
                      }, [
                        _createVNode(_component_ResultItemsContainer, {
                          results: result,
                          ctas: settings.ctas,
                          ctaFrequency: settings.ctaFrequency,
                          resultType: _ctx.resultType,
                          language: _ctx.language
                        }, null, 8, ["results", "ctas", "ctaFrequency", "resultType", "language"])
                      ], 2))
                    : _createCommentVNode("", true),
                  (loading && !error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t("Web.Containers.LoadingResults")), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              (_ctx.currentActivePage < _ctx.totalPages)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["resultsAndButton", _ctx.resultType])
                  }, [
                    _createElementVNode("div", _hoisted_44, [
                      (result.totalResults > 0)
                        ? (_openBlock(), _createBlock(_component_ResultsIndicator, {
                            key: 0,
                            first: _ctx.firstPage(_ctx.currentActivePage, _ctx.pagesize),
                            term: _ctx.keywordInput,
                            last: _ctx.lastPage(result.totalResults, _ctx.pagesize),
                            total: result.totalResults,
                            indexTitle: _ctx.title
                          }, null, 8, ["first", "term", "last", "total", "indexTitle"]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("button", {
                          class: "button lineBtn",
                          onClick: _cache[16] || (_cache[16] = 
                        (evt) => {
                          evt.preventDefault();
                          _ctx.paginationClick(_ctx.currentActivePage + 1);
                        }
                      )
                        }, _toDisplayString(_ctx.$t("Web.Containers.ShowMore")), 1)
                      ])
                    ])
                  ], 2))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["parentid", "endPoint", "tags", "images", "additionalFields", "additionalFieldsMultiLingual", "page", "keyword", "pagesize", "sortOrder", "sortType", "sortIsDesc", "language", "personalisationGroupIds"])
        ])
      ]),
      _: 1
    }, 8, ["parentid", "endPoint", "culture"])
  ]))
}